import { SalesOrderItemType } from '../constants/sales-order-item-type.js';
import { orderLineFamily } from './order-line-family.js';
const FAMILY_BEARING_TYPES = {
    sample: [SalesOrderItemType.SAMPLE],
    sales: [SalesOrderItemType.SALE, SalesOrderItemType.PROMO],
};
const ALL_FAMILY_BEARING_TYPES = [
    ...FAMILY_BEARING_TYPES.sample,
    ...FAMILY_BEARING_TYPES.sales,
];
/** Family-bearing types still addable to this order — all three if unestablished, else only its family's. */
export function allowedLineTypes(items) {
    const family = orderLineFamily(items);
    if (!family)
        return ALL_FAMILY_BEARING_TYPES;
    return FAMILY_BEARING_TYPES[family];
}
//# sourceMappingURL=allowed-line-types.js.map